import React, { useState, useEffect } from "react";
import Logo from "../../components/Logo/Logo";
import { information, support, socialNetwork } from "../../data";
import { animateScroll } from "react-scroll";
import { MdExpandLess } from "react-icons/md";

const Footer = () => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
    <footer className={`footer-area footer--2`}>
      <div className={`dg__footer__container bg--white`}>
        <div className="container">
          <div className="row">
            {/* Start Single Widget */}
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 col-12">
              <div className="footer__widget">
                <div className="footer__inner">
                  <a href={process.env.PUBLIC_URL} className="logo" style={{ color: "black" }}>
                    <Logo image={"/images/logo/2.png"} />
                  </a>

                  <p>
                    lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed
                  </p>
                </div>
              </div>
            </div>
            {/* End Single Widget */}
            {/* Start Single Widget */}
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 xs__mt--40">
              <div className="footer__widget information">
                <h4>Information</h4>
                <div className="footer__inner">
                  <ul className="ft__menu">
                    {information.map((val, index) => {
                      return (
                        <li key={index}>
                          <a 
                          href={process.env.PUBLIC_URL + val.url}
                          target="_blank"
                          rel="noopener noreferrer"
                         >
                            {val.title}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            {/* End Single Widget */}
            {/* Start Single Widget */}
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 md__mt--40 sm__mt--40">
              <div className="footer__widget support">
                <h4>Support</h4>
                <div className="footer__inner">
                  <ul className="ft__menu">
                    {support.map((val, index) => {
                      return (
                        <li key={index}>
                          <a 
                          href={process.env.PUBLIC_URL + val.url}
                          target="_blank"
                          rel="noopener noreferrer"
                         >
                            {val.title}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            {/* End Single Widget */}
            {/* Start Single Widget */}
            <div className="col-lg-3 col-md-6 col-sm-6 md__mt--40 sm__mt--40">
              <div className="footer__widget resources">
                <h4>Contact</h4>
                <div className="footer__inner">
                  <ul>
                    <li>support@galataanket.com</li>
                    <li>Address: lorem</li>
                    <li>Phone: +11 1111 111 111</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* End Single Widget */}
          </div>
        </div>
      </div>
      <div className={`copyright bg__color--1`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-sm-6 col-12">
              <div className="copyright__inner">
                <p className="copyright-text">
                  &copy; Galata Anket {new Date().getFullYear()}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 col-12">
              <ul className="footer__right social__icon">
                {socialNetwork.map((val, index) => {
                  return (
                    <li key={index}>
                      <a
                        href={val.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={val.title}
                      >
                        {val.icon}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <MdExpandLess />
      </button>
    </footer>
  );
};

export default Footer;
